import Client from '@/client'

export default {
  list(offset, limit=20) {
    let query = `{id,uuid,name,prediction{name},owner{id,name},config,status,updated_at}`
    return Client.get(`exports/`, { params: { limit: limit, offset: offset, query: query }})
  },
  create(payload) {
    return Client.post(`exports/`, payload)
  },
  retrieve(uuid) {
    return Client.get(`exports/${uuid}/`)
  },
  head(id, start = 0) {
    return Client.get(`exports/${id}/head/`, { params: { start: start } })
  },
  info(id) {
    return Client.get(`exports/${id}/info/`)
  },
  stats(id, column) { 
    return Client.get(`exports/${id}/stats`, { params: { column: column }})
  },
  download(uuid) {
    return Client.get(`exports/${uuid}/download/`)
  },
  refresh(uuid) {
    return Client.post(`exports/${uuid}/refresh/`)
  },
  update(id, payload) {
    return Client.put(`exports/${id}/`, payload)
  },
  patch(id, payload) {
    return Client.patch(`exports/${id}/`, payload)
  },
  clone(id, payload) {
    return Client.post(`exports/${id}/clone/`, payload)
  },
  destroy(id) {
    return Client.delete(`exports/${id}/`)
  },
  delete(payload) {
    return Client.post('exports/delete/', payload)
  }
}